<template>
  <div v-if="item.children.length == 0">
    <a
      :href="item.destination"
      target="_blank"
      :class="$route.name == item.destination ? '!text-primary  shadow' : ''"
      class="p-1 flex items-center gap-2 text-neutral-600 cursor-pointer rounded-md hover:bg-neutral-100 hover:text-primary hover:gap-3 transition-all overflow-hidden"
      v-if="item.isExternal"
    >
      <span class="material-symbols-outlined text-md">
        {{ item.icon }}
      </span>
      {{ item.label }}
    </a>
    <router-link
      v-else
      :to="{ name: item.destination }"
      :is="$route.name == item.destination ? 'span' : 'router-link'"
      :class="$route.name == item.destination ? '!text-primary  shadow' : ''"
      class="p-1 flex items-center gap-2 text-neutral-600 cursor-pointer rounded-md hover:bg-neutral-100 hover:text-primary hover:gap-3 transition-all overflow-hidden"
    >
      <div class="relative">
        <span class="material-symbols-outlined text-md">
          {{ item.icon }}
        </span>
      </div>
      <div v-if="item.parent" class="flex items-center justify-center gap-1">
        <span class="text-xs shrink-0">{{ item.parent }} > </span>
        <span class="text-xs shrink-0">{{ item.label }}</span>
      </div>
      <span
        v-else
        class="text-md shrink-0"
        :class="{ 'text-sm': isLongLabel() }"
        >{{ item.label }}</span
      >
    </router-link>
  </div>
  <div v-else>
    <div
      class="p-1 flex items-center gap-2 text-neutral-600 cursor-pointer rounded-md hover:bg-neutral-100 hover:text-primary hover:gap-3 transition-all"
      @click="toggleItem(item.label)"
    >
      <span class="material-symbols-outlined text-md">
        {{ item.icon }}
      </span>
      <span class="text-md shrink-0">{{ item.label }}</span>
      <span
        class="material-symbols-outlined text-md transition-all duration-500"
        :class="expandedItem == item.label ? 'rotate-180' : ''"
      >
        expand_more
      </span>
    </div>
    <div
      class="flex-col gap-1 p-2 max-h-0 opacity-0 hidden"
      :class="expandedItem == item.label ? 'max-h-full opacity-100 !flex' : ''"
    >
      <div v-for="(child, i) in permittedChildren" :key="i">
        <router-link
          :to="{ name: child.destination }"
          :is="$route.name == child.destination ? 'span' : 'router-link'"
          :class="
            $route.name == child.destination ? '!text-primary  shadow' : ''
          "
          class="p-1 flex items-center gap-2 text-neutral-600 cursor-pointer rounded-md hover:bg-neutral-100 hover:text-primary hover:gap-3 transition-all"
        >
          <div class="relative">
            <span class="material-symbols-outlined text-md">
              {{ child.icon }}
            </span>
          </div>
          <span class="text-sm">{{ child.label }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  props: ["item"],
  data() {
    return {
      expandedItem: "",
    };
  },
  computed: {
    permittedChildren(): any[] {
      return (this.item?.children || []).filter((c: any) => c.isPermitted);
    },
  },
  methods: {
    toggleItem(item: string) {
      if (this.expandedItem == item) this.expandedItem = "";
      else this.expandedItem = item;
    },
    isLongLabel(): boolean {
      return this.item.label.length > 10;
    },
  },
});
</script>

<style></style>
